<template>
  <div v-if="isGs" class="gs-avatar-container">
    <div v-if="isGsCard" class="gs-icon">
      <md-avatar
        class="md-avatar-icon dropdown-toggle gs-avatar-card"
        :class="[`md-${size}`, `backgroundColor-${gsColor}`]"
      >
        {{ gsFirstLetter }} 
      </md-avatar>
    </div>
    <div v-else class="gs-icon">
      <md-avatar
        class="md-avatar-icon dropdown-toggle gs-avatar"
        :class="[`md-${size}`, `backgroundColor-${gsColor}`]"
      >
        {{ gsFirstLetter }} 
      </md-avatar>
    </div>
  </div>
  <div v-else class="avatar-container">
    <div class="user-icon">
      <md-avatar
        class="dropdown-toggle user-avatar"
        :class="[`md-${size}`, { 'send-user-avatar': this.sendPointsUser}]"
        v-if="userHasPhoto"
      >
        <img
          class="header-img"
          :src="userHeaderImg"
          alt="Avatar"
          :data-cy="decideTag"
          :width="chooseImgSize"
          :height="chooseImgSize"
        />
      </md-avatar>
      <md-avatar
        class="md-avatar-icon dropdown-toggle user-avatar"
        :class="[`md-${size}`, `backgroundColor-${userColor}`, { 'send-user-avatar': this.sendPointsUser}]"
        :data-cy="decideTag"
        v-else
      >
        {{ userFirstLetter }}
      </md-avatar>
      <img
        v-if="tryModeratorBadge && myUser.id === getModerator.id"
        class="moderator-badge"
        src="../../../public/svg-icons/moderatorBadge.png"
        alt="Moderator"
      />
    </div>
  </div>
</template>
<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelper from "../../mixins/GroupHelper.vue";

export default {
  name: "SUserAvatar",
  mixins: [UserHelperVue, GroupHelper],
  props: [
    "myUser",
    "size",
    "isLoggedUser",
    "isProfileAvatar",
    "tryModeratorBadge",
    "sendPointsUser",
    "isGs",
    "isGsCard"
  ],
  methods: {
    chooseImgSize() {
      switch (this.size) {
        case "x-small":
          return "34px";
        case "small":
          return "40px";
        case "x-medium":
          return "50px"
        case "search-user-size":
          return "75px";
        case "medium":
          return "75px";
        case "message-user":
          return "75px";
        case "large":
          return "100px";
        case "x-large":
          return "132px";
        default:
          return "75px";
      }
    },
  },
  computed: {
    decideTag() {
      return this.isProfileAvatar ? "userAvatarImage" : "";
    },
    userHasPhoto() {
      return this.myUser?.userHasPhoto ?? false;
    },
    userColor() {
      return this.isLoggedUser
        ? this.getUserColor()
        : this.getOthersColor(this.myUser);
    },
    userFirstLetter() {
      return this.isLoggedUser
        ? this.getUserFirstLetter()
        : this.getOthersFirstLetter(this.myUser);
    },
    gsFirstLetter() {
      return this.myUser.garageName.slice(0, 1).toUpperCase();
    },
    gsColor() {
      return "yellow-user";
    },
    userHeaderImg() {
      return this.getUserImagePath(this.myUser);
    },
  },
};
</script>
<style lang="scss" scoped>
.gs-avatar {
  border-radius: 150px;
}
.gs-avatar-card {
  margin: 0 !important;
}
.gs-avatar-container {
  margin-right: 10px;
}
.gs-icon {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-icon {
  width: 100%;
  height: 100%;
}
.md-avatar.md-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  font-size: 64px;
}
.md-avatar.md-medium {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  font-size: 48px;
}
.md-avatar.md-x-medium {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  font-size: 20px;
}
.md-avatar.md-small {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  font-size: 20px;
}

.md-avatar.md-x-small {
  min-width: 34px !important;
  width: 34px !important;
  height: 34px !important;
  font-size: 16px;
}
.send-user-avatar {
  border: 3px $primary;
  border-style: solid;
}
.md-avatar.md-message-user {
  margin-right: 0.6rem;
  margin-top: 1rem;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  font-size: 40px;
}
.md-avatar.md-x-large {
  font-size: 72px;
  width: 100%;
  height: 100%;
}

.md-avatar.md-search-user-size {
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  font-size: 25px;
}
@media (max-width: 1023px) {
  .md-avatar.md-x-large {
    font-size: 50px;
  }
  .gs-icon {
    width: 150px;
    height: 150px;
  }
}
@media (max-width: 620px) {
  .gs-icon {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 460px) {
  .md-avatar.md-x-large {
    font-size: 40px;
  }
  .gs-icon {
    width: 100px;
    height: 100px;
  }
}
.dropdown-toggle::after {
  content: none;
}
.moderator-badge {
  position: absolute;
  right: -9px;
  bottom: -7px;
  margin-right: unset !important;
  min-width: unset !important;
  max-width: unset !important;
  height: unset !important;
  width: unset !important;
}
.backgroundColor-cyan-user {
  background-color: $cyan-user !important;
}
.md-avatar.backgroundColor-dark-blue-user {
  background-color: $dark-blue-user !important;
}
.backgroundColor-purple-user {
  background-color: $purple-user !important;
}
.backgroundColor-green-user {
  background-color: $green-user !important;
}
.backgroundColor-gray-user {
  background-color: $gray-user !important;
}
.backgroundColor-orange-user {
  background-color: $orange-user !important;
}
.backgroundColor-yellow-user {
  background-color: $yellow-user !important;
}
</style>
